import React from 'react';
import { ChevronLeft, ChevronRight, Copy, Plus, Trash2 } from 'lucide-react';
import { useEditorStore } from '../store/editor';
import { CellSvg } from '../render/CellSvg';

export const CellStrip: React.FC = () => {
  const project = useEditorStore((state) => state.project);
  const activeCellId = useEditorStore((state) => state.activeCellId);
  const setActiveCell = useEditorStore((state) => state.setActiveCell);
  const addCell = useEditorStore((state) => state.addCell);
  const duplicateCell = useEditorStore((state) => state.duplicateCell);
  const deleteCell = useEditorStore((state) => state.deleteCell);
  const moveCell = useEditorStore((state) => state.moveCell);

  if (!project) return null;
  return (
    <section className="cell-strip" aria-label="Storyboard cells">
      <div className="cell-strip-scroll">
        {project.cells.map((cell, index) => (
          <div key={cell.id} className={`cell-strip-item ${activeCellId === cell.id ? 'is-active' : ''}`}>
            <button type="button" className="cell-thumbnail" onClick={() => setActiveCell(cell.id)} aria-label={`Edit ${cell.title || `scene ${index + 1}`}`}>
              <CellSvg project={project} cell={cell} preserveAspectRatio="xMidYMid slice" />
              <span className="cell-number">{index + 1}</span>
            </button>
            <span className="cell-strip-title">{cell.title || `Scene ${index + 1}`}</span>
            {activeCellId === cell.id && (
              <div className="cell-strip-actions">
                <button type="button" className="icon-button" onClick={() => moveCell(cell.id, -1)} disabled={index === 0} aria-label="Move cell left"><ChevronLeft size={15} /></button>
                <button type="button" className="icon-button" onClick={() => moveCell(cell.id, 1)} disabled={index === project.cells.length - 1} aria-label="Move cell right"><ChevronRight size={15} /></button>
                <button type="button" className="icon-button" onClick={() => duplicateCell(cell.id)} aria-label="Duplicate cell"><Copy size={15} /></button>
                <button type="button" className="icon-button danger" onClick={() => deleteCell(cell.id)} disabled={project.cells.length === 1} aria-label="Delete cell"><Trash2 size={15} /></button>
              </div>
            )}
          </div>
        ))}
        <button type="button" className="add-cell-card" onClick={addCell} disabled={project.cells.length >= 100}>
          <Plus size={24} />
          <span>Add cell</span>
        </button>
      </div>
    </section>
  );
};
